<script setup>
// "Mover para etapa" nos menus do card. Arrastar não funciona no toque
// (HTML5 draggable) nem por teclado; daqui o card anda no funil sem abrir a
// ficha. Quem move de fato é o KanbanTab, pelo mesmo caminho do soltar
// (motivo de perda, valor do ganho, desfazer e rollback).
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { stagesForMoveMenu } from '../helpers/moveToStage';

const props = defineProps({
  currentStage: { type: [String, Number], default: null },
});

const emit = defineEmits(['move']);

const { t } = useI18n();
const store = useStore();
const isOpen = ref(false);

const stages = computed(() =>
  stagesForMoveMenu(
    store.getters['funnel/getSelectedFunnel']?.stages,
    props.currentStage
  )
);

const pick = stageId => {
  isOpen.value = false;
  emit('move', stageId);
};
</script>

<template>
  <div v-if="stages.length">
    <button
      type="button"
      class="w-full min-h-8 px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-n-brand [@media(pointer:coarse)]:min-h-11"
      :aria-expanded="isOpen"
      data-test="kanban-move-to-stage"
      @click.stop="isOpen = !isOpen"
    >
      <span class="flex items-center gap-2">
        <span class="i-ph-arrow-right size-4" aria-hidden="true" />
        <span class="flex-1">{{ t('KANBAN.CONTEXT_MENU.MOVE_TO_STAGE') }}</span>
        <span
          class="size-3.5 transition-transform"
          :class="isOpen ? 'i-ph-caret-up' : 'i-ph-caret-down'"
          aria-hidden="true"
        />
      </span>
    </button>
    <ul
      v-if="isOpen"
      class="max-h-56 overflow-y-auto border-y border-n-weak bg-n-alpha-1"
      :aria-label="t('KANBAN.CONTEXT_MENU.MOVE_TO_STAGE')"
    >
      <li v-for="stage in stages" :key="stage.id">
        <button
          type="button"
          class="w-full min-h-8 pl-8 pr-3 py-1.5 text-left text-xs text-n-slate-12 hover:bg-n-alpha-2 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-n-brand [@media(pointer:coarse)]:min-h-11"
          @click.stop="pick(stage.id)"
        >
          <span class="flex items-center gap-2">
            <span
              class="size-2 shrink-0 rounded-full"
              :style="{ backgroundColor: stage.color }"
              aria-hidden="true"
            />
            <span class="truncate">{{ stage.name }}</span>
          </span>
        </button>
      </li>
    </ul>
  </div>
</template>
